<page-layout>
    <panel [showGoBack]="true" [title]="title" [icon]="icon" [goBackLink]="goBackLink">
        <ng-content></ng-content>
    </panel>
</page-layout>